const config = {
  apiUrl: `https://briefing.papello.com.br/api/`,
  url: 'https://briefing.papello.com.br',
};
// const config = {
//   apiUrl: `http://localhost:8000/`,
//   url: 'http://localhost:3000',
// }
export default config;